var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-container', {
    staticClass: "d-flex flex-column flex-nowrap pa-0",
    attrs: {
      "fluid": "",
      "fill-height": ""
    }
  }, [_c('div', {
    staticClass: "flex-grow-1 overflow-auto",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "id": "scrollArea"
    }
  }, [_c('div', {
    ref: "sortable",
    staticClass: "d-flex overflow-x-auto fill-height flex-grow-0 pa-1"
  }, _vm._l(_vm.taskTypes, function (tt) {
    return _c('TaskColumn', {
      key: tt.xid,
      ref: "taskType",
      refInFor: true,
      attrs: {
        "sortable-id": tt.xid,
        "taskType": tt
      }
    });
  }), 1)]), _c('div', {
    staticStyle: {
      "width": "100%",
      "position": "relative"
    },
    attrs: {
      "id": "toolbarArea"
    }
  }, [_c('v-divider'), _c('div', {
    staticClass: "grey lighten-3 pa-2 text-caption"
  }, [_c('v-btn', {
    attrs: {
      "small": "",
      "color": "primary mr-4"
    }
  }, [_vm._v("...")])], 1)], 1)]);
}
var staticRenderFns = []

export { render, staticRenderFns }